import React, {Fragment, PureComponent} from 'react';
import {Badge, CardBody, CardFooter, CardHeader, CardText, CardTitle} from 'reactstrap';
import LinkIcon from 'react-feather/dist/icons/link.js';

import BlueCheck from '../../BlueCheck/BlueCheck.jsx';
import Date from '../../../../shared/components/Moment/Date.jsx';
import Datetime from '../../../../shared/components/Moment/Datetime.jsx';
import FrontCard from '../FrontCard.jsx';
import Skills from '../../Skills/Skills.jsx';
import StateLabel from '../../Offer/StateLabel/StateLabel.jsx';

export default class OfferFrontCard extends PureComponent {
  render() {
    const {isAdmin, offer} = this.props;
    const smsSent = offer?.sms_ticket?.nb_sendings ?? 0;

    return (
      <FrontCard>
        <CardHeader className={`d-flex ${isAdmin ? 'justify-content-between' : 'justify-content-center'}`}>
          <StateLabel filled={offer.filled} locked={offer.locked} published={offer.published}/>
          {isAdmin && offer.nbOfferAnswer > 0 ? offer.nbOfferAnswer + ' candidature(s)' : ''}
          {isAdmin && smsSent > 0 ? <div><Badge color="info">{smsSent} sms</Badge></div> : ''}
        </CardHeader>
        <CardBody>
          <div className="arrow-right"><LinkIcon/></div>
          {offer.hasAnswer && !isAdmin ?
            <div className="check-right">
              <BlueCheck hasTooltip tooltipOverlay="J'ai postulé"/>
            </div> : ''
          }
          <CardTitle>{offer?.title ?? ''}</CardTitle>
          <CardText tag="div">
            {isAdmin ?
              <Fragment>
                <p>Client : {offer?.client_name ?? 'N/A'}</p>
                <p>Publiée le <Datetime date={offer?.publication_date ?? null}/></p>
              </Fragment>: ''
            }
            <p>{offer?.sub_title ?? ''}</p>
            <p>
              {isAdmin ?
                offer?.city[0].label ?? '' :
                offer?.city[0].departement ?? ''
              }
            </p>
            {offer.keywords.length ?
              <Skills
                key={offer.id}
                length={offer?.keywords_length ?? 3}
                className="skills flex-wrap mx-3 mt-3"
                list={offer.keywords}
                forceNoLink={true}
              /> : ''
            }
          </CardText>
        </CardBody>
        <CardFooter>
          <Date date={offer.start_date}/>
          <span>{offer?.tjm_text ?? 'Non précisé'}</span>
        </CardFooter>
      </FrontCard>
    );
  }
}